
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.508 11H2.5a1 1 0 01-1-.999V5.49c0-.416.224-.924.53-1.207l3.262-3.008a1.053 1.053 0 011.416 0L9.97 4.282c.307.283.53.791.53 1.207V10a1 1 0 01-1.002 1h-3.99zm-1-1h4.99C9.5 10 9.5 8.496 9.5 5.489a.824.824 0 00-.208-.472L6.03 2.01c-.013-.012-.047-.012-.06 0L2.708 5.017a.826.826 0 00-.208.472V10h2.008zm2.9-4.867A.65.65 0 018.375 6L5.787 8.957a.65.65 0 01-.409.21l-.068.005-.072-.004a.65.65 0 01-.359-.157l-.048-.046L3.426 7.39a.65.65 0 01.898-.94l.05.05.925 1.066 2.11-2.433z"}})])
          )
        }
      }
    